import React from 'react';
import { ErrorMessage } from 'ui-toolkit';

interface IErrorWrapperProps {
  errorMessage?: React.ReactNode;
  error?: Error | null;
  children?: React.ReactNode;
}

export default class ErrorWrapper extends React.Component<IErrorWrapperProps> {
  public render() {
    const { children, errorMessage, error } = this.props;
    return errorMessage ? <ErrorMessage error={error}>{errorMessage}</ErrorMessage> : children;
  }
}
